var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidenavNotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 811452"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.7182 12.1412C21.7182 10.7851 21.7182 9.48792 21.7182 8.19077C21.7182 6.95259 21.7182 5.65544 21.7182 4.41726C21.7182 4.12246 21.6003 4.06349 21.3644 4.06349C15.2325 4.06349 9.04155 4.06349 2.90959 4.06349C2.55583 4.06349 2.49687 4.18142 2.49687 4.47622C2.49687 9.19311 2.49687 13.91 2.49687 18.6859C2.49687 19.1575 2.49687 19.6292 2.49687 20.1009C2.49687 21.0443 2.79167 21.3391 3.73505 21.3391C5.85765 21.3391 7.98025 21.3391 10.1029 21.3391C10.9283 21.3391 11.8127 21.3391 12.6382 21.3391C13.0509 21.3391 13.0509 21.3391 12.933 21.7518C12.8151 22.1056 12.6971 22.5183 12.5792 22.8721C12.5203 23.1669 12.3434 23.2848 12.0486 23.2848C9.33636 23.2848 6.56518 23.2848 3.85297 23.2848C3.44024 23.2848 3.02752 23.2848 2.61479 23.1669C1.3766 22.8131 0.492188 21.6929 0.492188 20.3368C0.492188 14.5586 0.492188 8.83935 0.492188 3.06116C0.492188 1.4692 1.78933 0.172059 3.38128 0.113098C9.15947 0.113098 14.9377 0.113098 20.7159 0.113098C22.3078 0.113098 23.6049 1.41024 23.6049 3.00219C23.6049 5.83233 23.6049 8.66246 23.6049 11.4926C23.6049 11.7874 23.546 11.9053 23.1922 11.8464C22.7795 11.7874 22.2488 11.9053 21.7182 12.1412Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7182 12.1412C21.7182 10.7851 21.7182 9.48792 21.7182 8.19077C21.7182 6.95259 21.7182 5.65544 21.7182 4.41726C21.7182 4.12246 21.6003 4.06349 21.3644 4.06349C15.2325 4.06349 9.04155 4.06349 2.90959 4.06349C2.55583 4.06349 2.49687 4.18142 2.49687 4.47622C2.49687 9.19311 2.49687 13.91 2.49687 18.6859C2.49687 19.1575 2.49687 19.6292 2.49687 20.1009C2.49687 21.0443 2.79167 21.3391 3.73505 21.3391C5.85765 21.3391 7.98025 21.3391 10.1029 21.3391C10.9283 21.3391 11.8127 21.3391 12.6382 21.3391C13.0509 21.3391 13.0509 21.3391 12.933 21.7518C12.8151 22.1056 12.6971 22.5183 12.5792 22.8721C12.5203 23.1669 12.3434 23.2848 12.0486 23.2848C9.33636 23.2848 6.56518 23.2848 3.85297 23.2848C3.44024 23.2848 3.02752 23.2848 2.61479 23.1669C1.3766 22.8131 0.492188 21.6929 0.492188 20.3368C0.492188 14.5586 0.492188 8.83935 0.492188 3.06116C0.492188 1.4692 1.78933 0.172059 3.38128 0.113098C9.15947 0.113098 14.9377 0.113098 20.7159 0.113098C22.3078 0.113098 23.6049 1.41024 23.6049 3.00219C23.6049 5.83233 23.6049 8.66246 23.6049 11.4926C23.6049 11.7874 23.546 11.9053 23.1922 11.8464C22.7795 11.7874 22.2488 11.9053 21.7182 12.1412Z",
    fill: "url(#paint0_linear_698_4847)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7182 12.1412C21.7182 10.7851 21.7182 9.48792 21.7182 8.19077C21.7182 6.95259 21.7182 5.65544 21.7182 4.41726C21.7182 4.12246 21.6003 4.06349 21.3644 4.06349C15.2325 4.06349 9.04155 4.06349 2.90959 4.06349C2.55583 4.06349 2.49687 4.18142 2.49687 4.47622C2.49687 9.19311 2.49687 13.91 2.49687 18.6859C2.49687 19.1575 2.49687 19.6292 2.49687 20.1009C2.49687 21.0443 2.79167 21.3391 3.73505 21.3391C5.85765 21.3391 7.98025 21.3391 10.1029 21.3391C10.9283 21.3391 11.8127 21.3391 12.6382 21.3391C13.0509 21.3391 13.0509 21.3391 12.933 21.7518C12.8151 22.1056 12.6971 22.5183 12.5792 22.8721C12.5203 23.1669 12.3434 23.2848 12.0486 23.2848C9.33636 23.2848 6.56518 23.2848 3.85297 23.2848C3.44024 23.2848 3.02752 23.2848 2.61479 23.1669C1.3766 22.8131 0.492188 21.6929 0.492188 20.3368C0.492188 14.5586 0.492188 8.83935 0.492188 3.06116C0.492188 1.4692 1.78933 0.172059 3.38128 0.113098C9.15947 0.113098 14.9377 0.113098 20.7159 0.113098C22.3078 0.113098 23.6049 1.41024 23.6049 3.00219C23.6049 5.83233 23.6049 8.66246 23.6049 11.4926C23.6049 11.7874 23.546 11.9053 23.1922 11.8464C22.7795 11.7874 22.2488 11.9053 21.7182 12.1412Z",
    fill: "url(#paint1_linear_698_4847)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7182 12.1412C21.7182 10.7851 21.7182 9.48792 21.7182 8.19077C21.7182 6.95259 21.7182 5.65544 21.7182 4.41726C21.7182 4.12246 21.6003 4.06349 21.3644 4.06349C15.2325 4.06349 9.04155 4.06349 2.90959 4.06349C2.55583 4.06349 2.49687 4.18142 2.49687 4.47622C2.49687 9.19311 2.49687 13.91 2.49687 18.6859C2.49687 19.1575 2.49687 19.6292 2.49687 20.1009C2.49687 21.0443 2.79167 21.3391 3.73505 21.3391C5.85765 21.3391 7.98025 21.3391 10.1029 21.3391C10.9283 21.3391 11.8127 21.3391 12.6382 21.3391C13.0509 21.3391 13.0509 21.3391 12.933 21.7518C12.8151 22.1056 12.6971 22.5183 12.5792 22.8721C12.5203 23.1669 12.3434 23.2848 12.0486 23.2848C9.33636 23.2848 6.56518 23.2848 3.85297 23.2848C3.44024 23.2848 3.02752 23.2848 2.61479 23.1669C1.3766 22.8131 0.492188 21.6929 0.492188 20.3368C0.492188 14.5586 0.492188 8.83935 0.492188 3.06116C0.492188 1.4692 1.78933 0.172059 3.38128 0.113098C9.15947 0.113098 14.9377 0.113098 20.7159 0.113098C22.3078 0.113098 23.6049 1.41024 23.6049 3.00219C23.6049 5.83233 23.6049 8.66246 23.6049 11.4926C23.6049 11.7874 23.546 11.9053 23.1922 11.8464C22.7795 11.7874 22.2488 11.9053 21.7182 12.1412Z",
    fill: "url(#paint2_linear_698_4847)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.642 25.1131C14.2882 25.1131 14.0524 24.9362 14.1703 24.5825C14.4651 23.4032 14.8189 22.283 15.1727 21.1627C15.2316 21.0448 15.2906 20.9269 15.4085 20.8679C16.8825 19.3939 18.3566 17.9198 19.7716 16.4458C19.9485 16.2689 20.0664 16.2689 20.2433 16.4458C21.1277 17.3302 22.0122 18.2147 22.8966 19.0991C23.0145 19.217 23.0735 19.3349 22.8966 19.4528C21.3636 20.9269 19.8896 22.4599 18.4155 23.9339C18.2976 24.0518 18.1797 24.1108 18.0028 24.1697C16.9415 24.4645 15.8802 24.8183 14.8189 25.1131C14.7599 25.0541 14.701 25.0541 14.642 25.1131Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.642 25.1131C14.2882 25.1131 14.0524 24.9362 14.1703 24.5825C14.4651 23.4032 14.8189 22.283 15.1727 21.1627C15.2316 21.0448 15.2906 20.9269 15.4085 20.8679C16.8825 19.3939 18.3566 17.9198 19.7716 16.4458C19.9485 16.2689 20.0664 16.2689 20.2433 16.4458C21.1277 17.3302 22.0122 18.2147 22.8966 19.0991C23.0145 19.217 23.0735 19.3349 22.8966 19.4528C21.3636 20.9269 19.8896 22.4599 18.4155 23.9339C18.2976 24.0518 18.1797 24.1108 18.0028 24.1697C16.9415 24.4645 15.8802 24.8183 14.8189 25.1131C14.7599 25.0541 14.701 25.0541 14.642 25.1131Z",
    fill: "url(#paint3_linear_698_4847)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.1059 13.6152C9.98334 13.6152 7.86074 13.6152 5.73814 13.6152C5.44333 13.6152 5.32541 13.4973 5.38437 13.2025C5.38437 12.7897 5.38437 12.377 5.38437 11.9053C5.38437 11.7284 5.44333 11.6105 5.62021 11.6695C5.67917 11.6695 5.7971 11.6695 5.85606 11.6695C10.0423 11.6695 14.2285 11.6695 18.4148 11.6695C18.7685 11.6695 18.8865 11.7874 18.8275 12.1412C18.7685 12.4949 18.8275 12.8487 18.8275 13.2025C18.8275 13.4973 18.7685 13.6152 18.4737 13.6152C16.3511 13.6152 14.2285 13.6152 12.1059 13.6152Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1059 13.6152C9.98334 13.6152 7.86074 13.6152 5.73814 13.6152C5.44333 13.6152 5.32541 13.4973 5.38437 13.2025C5.38437 12.7897 5.38437 12.377 5.38437 11.9053C5.38437 11.7284 5.44333 11.6105 5.62021 11.6695C5.67917 11.6695 5.7971 11.6695 5.85606 11.6695C10.0423 11.6695 14.2285 11.6695 18.4148 11.6695C18.7685 11.6695 18.8865 11.7874 18.8275 12.1412C18.7685 12.4949 18.8275 12.8487 18.8275 13.2025C18.8275 13.4973 18.7685 13.6152 18.4737 13.6152C16.3511 13.6152 14.2285 13.6152 12.1059 13.6152Z",
    fill: "url(#paint4_linear_698_4847)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1059 13.6152C9.98334 13.6152 7.86074 13.6152 5.73814 13.6152C5.44333 13.6152 5.32541 13.4973 5.38437 13.2025C5.38437 12.7897 5.38437 12.377 5.38437 11.9053C5.38437 11.7284 5.44333 11.6105 5.62021 11.6695C5.67917 11.6695 5.7971 11.6695 5.85606 11.6695C10.0423 11.6695 14.2285 11.6695 18.4148 11.6695C18.7685 11.6695 18.8865 11.7874 18.8275 12.1412C18.7685 12.4949 18.8275 12.8487 18.8275 13.2025C18.8275 13.4973 18.7685 13.6152 18.4737 13.6152C16.3511 13.6152 14.2285 13.6152 12.1059 13.6152Z",
    fill: "url(#paint5_linear_698_4847)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.1067 7.89608C14.2293 7.89608 16.3519 7.89608 18.4745 7.89608C18.7693 7.89608 18.8872 7.95505 18.8872 8.24985C18.8872 8.66258 18.8872 9.07531 18.8872 9.48803C18.8872 9.72388 18.8283 9.78284 18.5924 9.78284C14.2883 9.78284 9.9841 9.78284 5.62098 9.78284C5.44409 9.78284 5.32617 9.72388 5.32617 9.54699C5.32617 9.13427 5.32617 8.72154 5.32617 8.36777C5.32617 8.01401 5.38513 7.89608 5.7389 7.89608C7.92046 7.89608 9.9841 7.89608 12.1067 7.89608Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1067 7.89608C14.2293 7.89608 16.3519 7.89608 18.4745 7.89608C18.7693 7.89608 18.8872 7.95505 18.8872 8.24985C18.8872 8.66258 18.8872 9.07531 18.8872 9.48803C18.8872 9.72388 18.8283 9.78284 18.5924 9.78284C14.2883 9.78284 9.9841 9.78284 5.62098 9.78284C5.44409 9.78284 5.32617 9.72388 5.32617 9.54699C5.32617 9.13427 5.32617 8.72154 5.32617 8.36777C5.32617 8.01401 5.38513 7.89608 5.7389 7.89608C7.92046 7.89608 9.9841 7.89608 12.1067 7.89608Z",
    fill: "url(#paint6_linear_698_4847)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1067 7.89608C14.2293 7.89608 16.3519 7.89608 18.4745 7.89608C18.7693 7.89608 18.8872 7.95505 18.8872 8.24985C18.8872 8.66258 18.8872 9.07531 18.8872 9.48803C18.8872 9.72388 18.8283 9.78284 18.5924 9.78284C14.2883 9.78284 9.9841 9.78284 5.62098 9.78284C5.44409 9.78284 5.32617 9.72388 5.32617 9.54699C5.32617 9.13427 5.32617 8.72154 5.32617 8.36777C5.32617 8.01401 5.38513 7.89608 5.7389 7.89608C7.92046 7.89608 9.9841 7.89608 12.1067 7.89608Z",
    fill: "url(#paint7_linear_698_4847)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.8841 15.62C16.9997 16.2096 16.1153 16.7992 15.2898 17.4478C15.1719 17.5067 15.054 17.5067 14.8771 17.5067C11.8111 17.5067 8.74515 17.5067 5.73814 17.5067C5.44333 17.5067 5.32541 17.4478 5.38437 17.153C5.38437 16.7403 5.38437 16.3275 5.38437 15.8558C5.38437 15.62 5.44333 15.5021 5.67917 15.5021C6.97632 15.5021 8.27346 15.5021 9.62957 15.5021C12.4007 15.5021 15.113 15.5021 17.8841 15.5021C17.8841 15.561 17.8841 15.62 17.8841 15.62Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8841 15.62C16.9997 16.2096 16.1153 16.7992 15.2898 17.4478C15.1719 17.5067 15.054 17.5067 14.8771 17.5067C11.8111 17.5067 8.74515 17.5067 5.73814 17.5067C5.44333 17.5067 5.32541 17.4478 5.38437 17.153C5.38437 16.7403 5.38437 16.3275 5.38437 15.8558C5.38437 15.62 5.44333 15.5021 5.67917 15.5021C6.97632 15.5021 8.27346 15.5021 9.62957 15.5021C12.4007 15.5021 15.113 15.5021 17.8841 15.5021C17.8841 15.561 17.8841 15.62 17.8841 15.62Z",
    fill: "url(#paint8_linear_698_4847)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8841 15.62C16.9997 16.2096 16.1153 16.7992 15.2898 17.4478C15.1719 17.5067 15.054 17.5067 14.8771 17.5067C11.8111 17.5067 8.74515 17.5067 5.73814 17.5067C5.44333 17.5067 5.32541 17.4478 5.38437 17.153C5.38437 16.7403 5.38437 16.3275 5.38437 15.8558C5.38437 15.62 5.44333 15.5021 5.67917 15.5021C6.97632 15.5021 8.27346 15.5021 9.62957 15.5021C12.4007 15.5021 15.113 15.5021 17.8841 15.5021C17.8841 15.561 17.8841 15.62 17.8841 15.62Z",
    fill: "url(#paint9_linear_698_4847)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.0145 13.7334C23.1914 13.7334 23.4272 13.7924 23.6041 13.9693C24.1937 14.4999 24.7244 15.0306 25.255 15.6202C25.5498 15.9739 25.6088 16.5046 25.314 16.8583C24.9602 17.33 24.5475 17.6248 24.1348 18.0376C24.0168 18.1555 23.9579 18.0965 23.8989 18.0376C23.0145 17.1532 22.1301 16.3277 21.2457 15.4433C21.1277 15.3254 21.1277 15.2664 21.2457 15.1485C21.5994 14.7947 21.9532 14.382 22.307 14.0282C22.4839 13.7924 22.7197 13.7334 23.0145 13.7334Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0145 13.7334C23.1914 13.7334 23.4272 13.7924 23.6041 13.9693C24.1937 14.4999 24.7244 15.0306 25.255 15.6202C25.5498 15.9739 25.6088 16.5046 25.314 16.8583C24.9602 17.33 24.5475 17.6248 24.1348 18.0376C24.0168 18.1555 23.9579 18.0965 23.8989 18.0376C23.0145 17.1532 22.1301 16.3277 21.2457 15.4433C21.1277 15.3254 21.1277 15.2664 21.2457 15.1485C21.5994 14.7947 21.9532 14.382 22.307 14.0282C22.4839 13.7924 22.7197 13.7334 23.0145 13.7334Z",
    fill: "url(#paint10_linear_698_4847)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_698_4847",
    x1: 12.0486,
    y1: 0.113098,
    x2: 12.0486,
    y2: 23.2848,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4237C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B2C6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_698_4847",
    x1: 0.459658,
    y1: 11.5721,
    x2: 23.6589,
    y2: 11.5721,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8028"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCD973"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_698_4847",
    x1: 12.0486,
    y1: 0.113098,
    x2: 12.0486,
    y2: 23.2848,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4237C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B2C6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_698_4847",
    x1: 18.5739,
    y1: 16.3132,
    x2: 18.5739,
    y2: 25.1131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4237C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B2C6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_698_4847",
    x1: 12.1058,
    y1: 11.6541,
    x2: 12.1058,
    y2: 13.6152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4237C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B2C6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_698_4847",
    x1: 5.35067,
    y1: 12.6239,
    x2: 18.8734,
    y2: 12.6239,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8028"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCD973"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_698_4847",
    x1: 12.1067,
    y1: 7.89608,
    x2: 12.1067,
    y2: 9.78284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4237C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B2C6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_698_4847",
    x1: 5.30709,
    y1: 8.82913,
    x2: 18.9189,
    y2: 8.82913,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8028"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCD973"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_698_4847",
    x1: 11.6269,
    y1: 15.5021,
    x2: 11.6269,
    y2: 17.5067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4237C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B2C6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_698_4847",
    x1: 5.35202,
    y1: 16.4934,
    x2: 17.9133,
    y2: 16.4934,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8028"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCD973"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_698_4847",
    x1: 23.3325,
    y1: 13.7334,
    x2: 23.3325,
    y2: 18.1056,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4237C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B2C6B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidenavNotes);
export default __webpack_public_path__ + "static/media/sidenav_notes.ce667e96fa59610355909b05b295defd.svg";
export { ForwardRef as ReactComponent };